import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import { API_URL } from '../../../config/constants';
import closeIconImg from '../../../images/closeIcon.png';
import moment from 'moment-timezone';
import './OperationRateDetailModal.scss';

Modal.setAppElement('#root');

const customStyle = {
    overlay: {
        backgroundColor: 'transparent'
        // zIndex: 98,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        padding: 'none',
        borderRadius: '10px',
        boxShadow: '7px 7px 5px rgba(0, 0, 0, 0.35)'
    },
};

function OperationRateDetailModal({ isOpen, onRequestClose, sdsData }) {
    const scrollAreaRef = useRef(null);
    const tbodyRef = useRef(null);
    const theadAreaRef = useRef(null);

    const [dataArr, setDataArr] = useState([]);

    function getScrollbarWidth() {
        const scrollDiv = document.createElement("div");
        scrollDiv.style.visibility = "hidden";
        scrollDiv.style.overflow = "scroll";
        scrollDiv.style.width = "100px";
        scrollDiv.style.height = "100px";
        document.body.appendChild(scrollDiv);

        const innerDiv = document.createElement("div");
        innerDiv.style.width = "100%";
        scrollDiv.appendChild(innerDiv);

        const scrollbarWidth = scrollDiv.offsetWidth - innerDiv.offsetWidth;
        scrollDiv.remove();

        return scrollbarWidth;
    }

    async function getOperationRateDetail() {
        const response = await axios.post(`${API_URL}/monitoring-manage/getOperationRateDetail`, { sumDsId: sdsData.sumDsId });
        const resData = response.data;
        const groupingObj = {};
        for (let i = 0; i < resData.length; i++) {
            const soleData = resData[i];
            const date = moment(soleData.time).tz("Asia/Seoul").format('YYYY-MM-DD');
            if (date in groupingObj) {
                // 객체에 해당 일자의 데이터가 있었던 경우
                // 해당 key의 값인 배열에 데이터 추가
                const prevArr = [...groupingObj[date]];
                const dupData = prevArr.find(el => el.worker === soleData.worker && el.modelId === soleData.modelId);
                if (!!dupData) {
                    const editingIdx = prevArr.findIndex(el1 => el1.idNo === dupData.idNo);
                    prevArr[editingIdx] = { ...dupData, time: soleData.time };
                } else {
                    prevArr.push(soleData);
                }
                groupingObj[date] = [...prevArr];
            } else {
                // 객체에 해당 일자의 데이터가 없는 경우
                // 새로운 key를 생성하고, 해당 배열에 데이터 추가
                groupingObj[date] = [soleData];
            }
        }
        const convertedArr = [...Object.keys(groupingObj)].map(date => ({ date: date, data: groupingObj[date].sort((a, b) => moment(b.time).valueOf() - moment(a.time).valueOf()) }));
        setDataArr([...convertedArr]);
    };

    console.log(dataArr)

    useEffect(() => {
        if (isOpen && sdsData !== null) {
            getOperationRateDetail();
        }
    }, [isOpen, sdsData])
    useEffect(() => {
        const theadThs = document.querySelectorAll(".tableHeader th");
        const tbodyTds = document.querySelectorAll(".tableBody table tr:first-child td");

        if (theadThs.length !== tbodyTds.length) return;

        tbodyTds.forEach((td, index) => {
            const width = td.getBoundingClientRect().width;
            theadThs[index].style.width = `${width}px`;
        });
    }, [dataArr]);
    useEffect(() => {
        const scrollbarWidth = tbodyRef.current && scrollAreaRef.current ? scrollAreaRef.current.offsetWidth - tbodyRef.current.clientWidth : 0;
        // console.log(scrollAreaRef.current.offsetWidth)
        // console.log(tbodyRef.current.clientWidth)
        console.log(scrollbarWidth)
        if (theadAreaRef.current) {
            theadAreaRef.current.style.paddingRight = `${scrollbarWidth}px`;
            console.log(theadAreaRef.current.style)
        }
    }, [dataArr]);

    return (
        <Modal
            isOpen={isOpen}
            style={customStyle}
            onRequestClose={onRequestClose}
            shouldCloseOnOverlayClick={false}
        >
            <div className='modalContentArea operationRateDetail'>
                <h2 className='modalTitle'>{`가동율 일자별 추이 - ${sdsData?.tableName}`}</h2>
                <button className='modalBtn closeBtn' onClick={onRequestClose}><img src={closeIconImg} alt={'창 닫기'} /></button>
                <div className='operationRateDetailTblArea'>
                    <div className='tableHeader' ref={theadAreaRef}>
                        <table >
                            <thead>
                                <tr>
                                    <th className='date'>일자</th>
                                    <th className='startTime'>시작 시간</th>
                                    <th className='endTime'>종료 시간</th>
                                    <th className='modelType'>차종</th>
                                    <th className='modelName'>품명</th>
                                    <th className='modelNo'>품번</th>
                                    <th className='worker'>작업자</th>
                                    <th className='currentProduce'>수량</th>
                                    <th className='totalProduce'>누적 수량</th>
                                    <th className='targetProduce'>목표 수량</th>
                                    <th className='operationRate'>가동율(%)</th>
                                </tr>
                                <tr style={{ height: '6px' }} />
                            </thead>
                        </table>
                    </div>
                    <div className='tableBody' id='scrollableBody' ref={scrollAreaRef}>
                        <table>
                            <tbody className='scrollableBody' ref={tbodyRef}>
                                {
                                    (() => {
                                        let prevTotalProduce = 0;

                                        return (dataArr.map((dataByDate, idx, array) => {
                                            const { date, data } = dataByDate;
                                            const dataAmount = data.length;
                                            if (dataAmount > 1) {
                                                return (
                                                    <React.Fragment key={`orDetTbl_${idx}`}>
                                                        {
                                                            data.map((soleData, innerIdx, innerArr) => {

                                                                let nextRowTP;
                                                                if (!!innerArr[innerIdx + 1]) {
                                                                    // 현재 일자의 다음 행이 있는 경우
                                                                    nextRowTP = innerArr[innerIdx + 1].totalProduce;
                                                                } else if (!!array[idx + 1]) {
                                                                    // 다음 일자가 있는 경우
                                                                    nextRowTP = array[idx + 1]["data"][0].totalProduce;
                                                                } else {
                                                                    // 둘 다 없는 경우
                                                                    nextRowTP = 0;
                                                                }

                                                                // 내 행의 누적수량 - 다음 행의 누적수량
                                                                let currentProduce = soleData.totalProduce - nextRowTP;
                                                                if (innerIdx === 0) {
                                                                    return (
                                                                        <tr key={`orDetTbl_tr_${idx}_${innerIdx}`}>
                                                                            <td className='date' rowSpan={dataAmount}>
                                                                                {date}
                                                                            </td>
                                                                            <td className='startTime'>{moment(soleData.time).tz("Asia/Seoul").format("HH:mm:ss")}</td>
                                                                            <td className='endTime'>{soleData.endTime ? moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") === "00:00:00" ? "24:00:00" : moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") : null}</td>
                                                                            <td className='modelType'>{soleData.Model.modelType}</td>
                                                                            <td className='modelName'>{soleData.Model.modelName}</td>
                                                                            <td className='modelNo'>{soleData.Model.modelNo}</td>
                                                                            <td className='worker'>{soleData.User.userName}</td>
                                                                            <td className='currentProduce'>{currentProduce < 0 ? '' : currentProduce}</td>
                                                                            <td className='totalProduce'>{soleData.totalProduce}</td>
                                                                            <td className='targetProduce'>{soleData.targetProduce}</td>
                                                                            <td className='operationRate'>{(soleData.totalProduce / soleData.targetProduce * 100).toFixed(2)}</td>
                                                                        </tr>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <tr key={`orDetTbl_tr_${idx}_${innerIdx}`}>
                                                                            <td className='startTime'>{moment(soleData.time).tz("Asia/Seoul").format("HH:mm:ss")}</td>
                                                                            <td className='endTime'>{soleData.endTime ? moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") === "00:00:00" ? "24:00:00" : moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") : null}</td>
                                                                            <td className='modelType'>{soleData.Model.modelType}</td>
                                                                            <td className='modelName'>{soleData.Model.modelName}</td>
                                                                            <td className='modelNo'>{soleData.Model.modelNo}</td>
                                                                            <td className='worker'>{soleData.User.userName}</td>
                                                                            <td className='currentProduce'>{currentProduce < 0 ? '' : currentProduce}</td>
                                                                            <td className='totalProduce'>{soleData.totalProduce}</td>
                                                                            <td className='targetProduce'>{soleData.targetProduce}</td>
                                                                            <td className='operationRate'>{(soleData.totalProduce / soleData.targetProduce * 100).toFixed(2)}</td>
                                                                        </tr>
                                                                    )

                                                                }
                                                            })
                                                        }
                                                    </React.Fragment>
                                                )

                                            } else {
                                                const soleData = data[0];

                                                let nextRowTP;
                                                if (!!array[idx + 1]) {
                                                    // 다음 일자가 있는 경우
                                                    nextRowTP = array[idx + 1]["data"][0].totalProduce;
                                                } else {
                                                    // 둘 다 없는 경우
                                                    nextRowTP = 0;
                                                }

                                                // 내 행의 누적수량 - 다음 행의 누적수량
                                                let currentProduce = soleData.totalProduce - nextRowTP;
                                                return (
                                                    <tr key={`orDetTbl_tr_${idx}`}>
                                                        <td className='date' rowSpan={dataAmount}>
                                                            {date}
                                                        </td>
                                                        <td className='startTime'>{moment(soleData.time).tz("Asia/Seoul").format("HH:mm:ss")}</td>
                                                        <td className='endTime'>{soleData.endTime ? moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") === "00:00:00" ? "24:00:00" : moment(soleData.endTime).tz("Asia/Seoul").format("HH:mm:ss") : null}</td>
                                                        <td className='modelType'>{soleData.Model.modelType}</td>
                                                        <td className='modelName'>{soleData.Model.modelName}</td>
                                                        <td className='modelNo'>{soleData.Model.modelNo}</td>
                                                        <td className='worker'>{soleData.User.userName}</td>
                                                        <td className='currentProduce'>{currentProduce < 0 ? '' : currentProduce}</td>
                                                        <td className='totalProduce'>{soleData.totalProduce}</td>
                                                        <td className='targetProduce'>{soleData.targetProduce}</td>
                                                        <td className='operationRate'>{(soleData.totalProduce / soleData.targetProduce * 100).toFixed(2)}</td>
                                                    </tr>
                                                )
                                            }
                                        }))
                                    })()
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

        </Modal >
    );
}

export default OperationRateDetailModal;
